





















import { Vue, Component } from 'vue-property-decorator'

@Component
export default class ConfigPage extends Vue {
  signOut() {
    (this as any).$gapi.signOut().then(console.log)
  }
}
